export const mockOrder = {
  orderNumber: 'MO-2026-00421',
  orderDate: 'June 6, 2026',
  status: 'Confirmed',
  estimatedDelivery: 'June 14 – June 18, 2026',
  email: 'sarah.johnson@email.com',
  shippingAddress: {
    name: 'Sarah Johnson',
    line1: '42 Maple Avenue, Apt 3B',
    city: 'Brooklyn',
    state: 'NY',
    zip: '11201',
    country: 'United States',
  },
  items: [
    {
      name: 'The H.O.M.E Collection',
      description: 'Journal + Card Deck Set',
      quantity: 1,
      price: 38000,
      image: 'https://readdy.ai/api/search-image?query=Hot%20magenta%20healing%20journal%20with%20open%20card%20deck%20fanned%20out%20together%20on%20dark%20marble%20surface%20luxury%20product%20photography%20editorial%20styling%20dramatic%20lighting%20feminine%20brand%20aesthetic%20deep%20rich%20shadows%20studio%20shot&width=400&height=400&seq=order-confirm-product&orientation=squarish',
    },
  ],
  subtotal: 38000,
  shipping: 0,
  tax: 3040,
  total: 41040,
  paymentMethod: {
    type: 'Visa',
    last4: '4242',
  },
  giftMessage: 'For your healing journey, with love. You are so worthy of this. — M.',
};